// organize global refetch handles
// example:
//  refetchHandles.pmInterests = props.data.refetch;
//  refetchHandles.pmInterests();
type RefetchHandle = () => void;

const noop = (): void => {};

export const refetchHandles: {
  pmInterests: RefetchHandle;
  activityFeed: RefetchHandle;
} = {
  pmInterests: noop, // dashboard where PMs get feed of data
  activityFeed: noop,
};
